export default function praProcessDirective() {
  return {
    template: require('./process.html'),
    scope: {
      assessment: '=',
      customerId: '<',
      process: '=',
      tooltipAppendToSelector: '@',
    },
    controller: 'PRAProcessController',
    controllerAs: 'praProcessVM',
    bindToController: true,
    replace: true,
  };
}
